export { default as TextInput } from './TextInput'
export { default as NumericInput } from './NumericInput'
export { default as Checkbox } from './Checkbox'
export { default as Select } from './Select'
export { default as SaveButton } from './SaveButton'
export { default as Label } from './Label'
export { default as WikiInput } from './WikiInput'


// WEBPACK FOOTER //
// ./client/src/components/forms/index.js